function Error() {
    return (
        <>
            <h1>ERROR 404: This page does not exist</h1>
        </>
    );
}

export default Error;
